import React, { useState, useEffect, useMemo } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/Button Triangle.png";
import FilterIcon from "../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import Dropdown from "../Dropdown";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";

const statusOptions = [
  { value: "Accepted By Courier Hub", label: "Accepted By Courier Hub" },
  { value: "Closed", label: "Closed" },
  { value: "In Transit", label: "In Transit" },
  { value: "Open", label: "Open" },
];

const OrderCourierFilterModal = ({
  show,
  handleClose,
  filterData,
  setFilterData,
  handleReset,
  bagList = [],
  applyFilters,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      companyId: filterData?.companyId || "",
      status: filterData?.status || [],
      createdDate: filterData?.createdDate || filterData?.fromDate || "",
    },
    mode: "onChange",
  });

  const watchedValues = watch();

  useEffect(() => {
    if (show) {
      reset({
        companyId: filterData?.companyId || "",
        status: filterData?.status || [],
        createdDate: filterData?.createdDate || filterData?.fromDate || "",
      });
    }
  }, [show, filterData, reset]);

  const [selectedTab, setSelectedTab] = useState("Bag No");
  const [loading, setLoading] = useState(false);

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const combinedBagNumbers = useMemo(() => {
    const bagSet = new Set();

    if (Array.isArray(bagList)) {
      bagList.forEach((item) => {
        const bag = item?.companyId || item?.bagNo;
        if (bag && typeof bag === "string" && bag.trim()) {
          bagSet.add(bag.trim());
        }
      });
    }

    const list = Array.from(bagSet);
    list.sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: "base", numeric: true })
    );
    return list;
  }, [bagList]);

  const currentBagNo =
    watchedValues?.companyId || filterData?.companyId || "";

  const bagDropdownOptions = useMemo(() => {
    const list = combinedBagNumbers.map((bag) => ({
      label: bag,
      value: bag,
    }));

    if (currentBagNo) {
      return [
        { label: "✕ Clear Bag No Selection", value: "" },
        ...list,
      ];
    }
    return list;
  }, [combinedBagNumbers, currentBagNo]);

  const hasActiveFilter = (tabName) => {
    switch (tabName) {
      case "Bag No":
        return Boolean(filterData?.companyId && filterData.companyId.trim() !== "");
      case "Status":
        return Boolean(filterData?.status && filterData.status.length > 0);
      case "Created Date":
        return Boolean(
          (filterData?.createdDate && filterData.createdDate.trim() !== "") ||
          (filterData?.fromDate && filterData.fromDate.trim() !== "") ||
          (filterData?.toDate && filterData.toDate.trim() !== "")
        );
      default:
        return false;
    }
  };

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const onSubmit = (formData) => {
    setFilterData(formData);
    if (applyFilters) {
      applyFilters(undefined, formData);
    }
    handleClose();
  };

  const onReset = () => {
    const emptyFilters = {
      companyId: "",
      status: [],
      createdDate: "",
      fromDate: "",
      toDate: "",
    };
    reset(emptyFilters);
    setFilterData(emptyFilters);
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title">Filter</h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="close icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {["Bag No", "Status", "Created Date"].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                            style={
                              hasActiveFilter(tab) && selectedTab !== tab
                                ? {
                                    outline: "2px solid #FF6B35",
                                    outlineOffset: "2px",
                                  }
                                : {}
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content !bg-[linear-gradient(to_bottom,#FFE8D4_0%_100%,transparent_25%_100%)]">
                      {selectedTab === "Bag No" && (
                        <Controller
                          name="companyId"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Bag No</label>
                              <div className="dateInputWrapper">
                                <Dropdown
                                  placeholder="Select Bag No"
                                  options={bagDropdownOptions}
                                  value={
                                    field.value ||
                                    watchedValues?.companyId ||
                                    filterData?.companyId ||
                                    ""
                                  }
                                  labelKey="label"
                                  valueKey="value"
                                  showSearch={true}
                                  selectClassName="!h-[38px] !rounded-[6px]"
                                  onChange={(item) => {
                                    const selectedBag =
                                      item && item.value ? item.value : "";
                                    field.onChange(selectedBag);
                                    setValue("companyId", selectedBag);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      companyId: selectedBag,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Status" && (
                        <div className="dateField">
                          <label
                            className="dateLabel"
                            style={{
                              marginBottom: "0.5rem",
                              fontWeight: "600",
                              fontSize: "20px",
                            }}
                          >
                            Status
                          </label>
                          <div
                            className="dateInputWrapper"
                            style={{
                              display: "flex",
                              gap: "1rem",
                              flexWrap: "wrap",
                              padding: "0.75rem",
                              backgroundColor: "#ffdab8",
                              border: "1px solid #ced4da",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {statusOptions.map((status) => (
                              <label
                                key={status.value}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={(
                                    filterData.status || []
                                  ).includes(status.value)}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const newStatus = isChecked
                                      ? [
                                          ...(filterData.status || []),
                                          status.value,
                                        ]
                                      : (filterData.status || []).filter(
                                          (v) => v !== status.value
                                        );
                                    setValue("status", newStatus);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: newStatus,
                                    }));
                                  }}
                                />
                                {status.label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}

                      {selectedTab === "Created Date" && (
                        <Controller
                          name="createdDate"
                          control={control}
                          rules={{
                            validate: {
                              validDate: (value) =>
                                !value ||
                                !isNaN(Date.parse(value)) ||
                                "Invalid Date",
                            },
                          }}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Created Date</label>
                              <div className="dateInputWrapper">
                                <input
                                  {...field}
                                  type="date"
                                  className="dateInput"
                                  max={getTodayDate()}
                                  value={field.value || ""}
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setValue("createdDate", e.target.value);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      createdDate: e.target.value,
                                    }));
                                  }}
                                />
                                {errors?.createdDate && (
                                  <div className="error-text">
                                    {errors.createdDate.message}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back w-[133px] !rounded-lg"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit w-[133px] !rounded-lg"
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderCourierFilterModal;
